import React, { useState } from "react";

import { TabSlider } from "@atsent/components";

import "./ProductPage.scss";

import {
  ProductDemo,
  ProductBatch,
  ProductAPI,
} from "components/template/Product";
import { HeaderNFooter } from "components/template/HeaderNFooter";
import { useLocation } from "react-router-dom";

const tabMenu = [
  { value: "demo", text: "Demo" },
  { value: "batch", text: "Batch" },
  { value: "api", text: "API 연동" },
];

const selectMenu = (val: string) => {
  switch (val) {
    case "demo":
      return <ProductDemo />;
    case "batch":
      window.history.replaceState(
        "",
        "",
        "/" + window.location.pathname.split("/")[1] + "/batch"
      );
      return <ProductBatch />;
    case "api":
      window.history.pushState(
        "",
        "",
        "/" + window.location.pathname.split("/")[1] + "/api-connect"
      );
      return <ProductAPI />;
  }
};

export const ProductPage: React.FC = () => {
  const location = useLocation();

  const [num] = useState(() => {
    switch (location.pathname.split("/")[2]) {
      case "demo":
        return 0;
      case "api-connect":
        return 2;
      case "batch":
      default:
        return 1;
    }
  });
  const [currentMenu, setCurrentMenu] = useState(() => tabMenu[num].value);
  return (
    <HeaderNFooter cx={"ProductPage"}>
      <TabSlider
        name={"product"}
        list={tabMenu}
        handleSetData={setCurrentMenu}
        defaultChecked={num}
      />
      {selectMenu(currentMenu)}
    </HeaderNFooter>
  );
};
